import React from "react";
import Typography from "@material-ui/core/Typography";
const ItemSellingPrice = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Item Selling Price
      </Typography>
      <Typography paragraph variant="h5">
        Set the default of product selling price as a base price
      </Typography>
      <Typography paragraph variant="body1">
        Item Selling Price is one of the features under the Sales module to
        manage the basic selling price of each product and will be used as the
        main pricing reference during sales activity. It contains any
        information regarding the price of each product including its variant if
        it exists. If the product pricing is not maintained in this feature, the
        pricing reference will follow the published price in the item master
        data. The product pricing will be maintained for each Customer Group and
        only applied for item types Finished Product, Service, Semi-Finished
        Product, and Raw Material.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Item Selling
        Price list for each Customer Group. It is displayed like a table that
        contains download functions, sort, filter, and global search on the
        header area, and contains data navigation and refresh function on the
        footer area. The data column that appears in this table list are listed
        below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item ID</b>
        <br />
        Indicates the ID of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Code</b>
        <br />
        Indicates the code of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Item Name</b>
        <br />
        Indicates the name of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Base Unit</b>
        <br />
        Indicates the base unit measurement of the Item.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Selling Price</b>
        <br />
        Indicates the basic price of the Item. In this column, an active textbox
        will appear for the user to input the pricing.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there is 1 button that appear on each row of Item Selling Price
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Alternative Variant Unit Prices</b>
        <br />
        This button is used to maintain the basic price of each variant that
        exists under each item. If an item has a variant and the pricing is
        maintained, then the selling price will follow the variant pricing
        instead of the main item pricing as the sales reference.
      </Typography>
    </React.Fragment>
  );
};

export default ItemSellingPrice;
